import React from "react";
import {
  getTodayInBrazil,
  formatDateForDisplay,
} from "../../../utils/dateUtils";
import { AdminPageHeader } from "../shared";
import { Icons } from "../../shared/Icons";
import { DailyBalance } from "./DailyBalance";
import { ReportsProfessionalSelect } from "./ReportsProfessionalSelect";
import { useAdminReportsProfessional } from "./useAdminReportsProfessional";

export const AdminCaixaDoDiaPage: React.FC = () => {
  const today = getTodayInBrazil();
  const {
    professionalIdForDailyBalance,
    showProfessionalSelector,
    professionals,
    selectedProfessionalId,
    setSelectedProfessionalId,
    loadingProfessionals,
  } = useAdminReportsProfessional();

  return (
    <div className="space-y-4 sm:space-y-6 md:space-y-8 animate-fade-in">
      <AdminPageHeader
        icon={<Icons.Receipt sx={{ fontSize: 28 }} />}
        title="Caixa do Dia"
        subtitle={`Hoje: ${formatDateForDisplay(today)} • Saldo e movimentação diária`}
        rightContent={
          showProfessionalSelector ? (
            <ReportsProfessionalSelect
              professionals={professionals}
              selectedProfessionalId={selectedProfessionalId}
              onSelectProfessional={setSelectedProfessionalId}
              loading={loadingProfessionals}
            />
          ) : undefined
        }
      />

      <div className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8">
        <DailyBalance professionalId={professionalIdForDailyBalance} />
      </div>
    </div>
  );
};
